<template>
  <div id="app">
    <Navigation></Navigation>
    <ActiveAlertBanner v-if="is_authenticated"></ActiveAlertBanner>
    <Notifications></Notifications>
    <br>
    <div class="container">
      <Infobar></Infobar>
      <br>
      <router-view v-if="is_authenticated"></router-view>
      <div v-else>
        <router-view name="non_authenticated"></router-view>
      </div>
      <hr>
      <p>&copy; {{ current_year }} - Galaxy Next Generation (G2) |
        <router-link :to="{ name: 'License' }">View License</router-link>
        | Version: {{ version }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'bootstrap'
import './assets/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/css/style.css'
import ActiveAlertBanner from './components/AppWide/ActiveAlertBanner'
import Navigation from './components/AppWide/Navigation'
import Notifications from './components/AppWide/Notifications'
import Infobar from './components/AppWide/Infobar'

export default {
  components: { Navigation, Notifications, Infobar, ActiveAlertBanner },

  computed: {
    ...mapGetters({
      current_year: 'currentYear',
      is_authenticated: 'isAuthenticated',
      version: 'version'
    })
  },
  methods: {
    is_active_alert() {
      this.$store.dispatch('getActiveAlertEvent')
    }
  },
  mounted () {
   this.is_active_alert()
    setInterval(() => {
      this.is_active_alert()
    }, 3000)
  },
  created () {
    this.$store.dispatch('isAuthenticated')
    this.$store.dispatch('getMachineType')
    this.$store.dispatch('getVersion')
  }
}
</script>
